{
  "familyId": "GET-BREUK-GETALLENLIJN",
  "questions": [
    {
      "id": "GET-BREUK-GETALLENLIJN-001",
      "familyId": "GET-BREUK-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Een getallenlijn loopt van 0 tot 1 en is verdeeld in 4 gelijke stukken. Op welk punt staat ¾?",
      "options": [
        "op het derde streepje",
        "op het tweede streepje",
        "op het vierde streepje",
        "op het eerste streepje"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 0,
            "end": 1,
            "step": 0.25,
            "label": "Getallenlijn van 0 tot 1, verdeeld in 4 gelijke stukken — tel zelf"
          },
          "a11y": { "alt": "Getallenlijn van 0 tot 1 met 4 gelijke stukken, geen markeringen op de tussenpunten" }
        }
      ],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 0,
            "end": 1,
            "step": 0.25,
            "marked": [0.75],
            "label": "¾ staat op het 3e streepje vanaf 0",
            "fractionLabels": { "0": "0", "0.25": "¼", "0.5": "½", "0.75": "¾", "1": "1" }
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuken op de getallenlijn",
            "content": "De noemer vertelt in hoeveel stukken de lijn is verdeeld. De teller vertelt hoeveel stukken je telt vanaf 0.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_getallenlijn_kwarten",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "De noemer vertelt in hoeveel stukken de lijn is verdeeld, de teller vertelt hoeveel stukken je telt. De noemer is 4, dus de lijn is verdeeld in 4 gelijke stukken. De teller is 3, dus je telt 3 stukken vanaf 0. Het derde streepje = ¾.",
        "solutionSteps": [
          "De noemer is 4 → de lijn is verdeeld in 4 gelijke stukken",
          "De teller is 3 → tel 3 stukken vanaf 0",
          "Het derde streepje = ¾"
        ],
        "distractorExplanations": {
          "0": "Goed! ¾ = 3 van de 4 stukken. Tel 3 streepjes vanaf 0: dat is het derde streepje.",
          "1": "Je dacht waarschijnlijk dat je 2 stukken moest tellen. Maar de teller is 3, niet 2. Het tweede streepje is ²⁄₄ = ½. Onthoud: de teller vertelt hoeveel stukken je telt.",
          "2": "Je dacht waarschijnlijk dat ¾ helemaal aan het einde ligt. Maar het vierde streepje is ⁴⁄₄ = 1 (het einde van de lijn). Onthoud: ¾ is drie kwart, niet vier kwart.",
          "3": "Je dacht waarschijnlijk dat je maar 1 stuk moest tellen. Maar de teller is 3, niet 1. Het eerste streepje is ¼. Onthoud: lees de teller goed — die vertelt hoeveel stukken je telt."
        }
      }
    },
    {
      "id": "GET-BREUK-GETALLENLIJN-002",
      "familyId": "GET-BREUK-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Op een getallenlijn van 0 tot 1, verdeeld in 5 gelijke stukken, welke breuk hoort bij het tweede streepje?",
      "options": [
        "²⁄₅",
        "²⁄₃",
        "⅕",
        "½"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 0,
            "end": 1,
            "step": 0.2,
            "marked": [0.4],
            "label": "Het 2e streepje is gemarkeerd — welke breuk is dit?"
          },
          "a11y": { "alt": "Getallenlijn 0-1 met 5 stukken, het tweede streepje is gemarkeerd zonder label" }
        }
      ],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 0,
            "end": 1,
            "step": 0.2,
            "marked": [0.4],
            "label": "Het 2e streepje van 5 = ²⁄₅",
            "fractionLabels": { "0": "0", "0.2": "⅕", "0.4": "⅖", "0.6": "⅗", "0.8": "⅘", "1": "1" }
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van streepje naar breuk",
            "content": "De verdeling bepaalt de noemer (hoeveel stukken). Het streepje bepaalt de teller (hoeveel stukken geteld).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_getallenlijn_vijfden",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "De verdeling bepaalt de noemer, het streepje bepaalt de teller. De lijn is verdeeld in 5 stukken, dus de noemer = 5. Het tweede streepje betekent teller = 2. De breuk is ²⁄₅.",
        "solutionSteps": [
          "De lijn is verdeeld in 5 stukken → noemer = 5",
          "Het tweede streepje → teller = 2",
          "De breuk is ²⁄₅"
        ],
        "distractorExplanations": {
          "0": "Goed! 5 stukken → noemer 5. Tweede streepje → teller 2. Breuk = ²⁄₅.",
          "1": "Je dacht waarschijnlijk dat de noemer 3 was. Maar de lijn is verdeeld in 5 stukken, niet 3. Onthoud: de noemer is altijd het totaal aantal stukken op de lijn.",
          "2": "Je dacht waarschijnlijk dat het tweede streepje bij ⅕ hoort. Maar ⅕ is het eerste streepje. Bij het tweede streepje heb je 2 stukken geteld. Onthoud: het streepjenummer = de teller.",
          "3": "Je dacht waarschijnlijk dat de lijn in 2 stukken was verdeeld. Maar de lijn is in 5 stukken verdeeld, dus het tweede streepje = ²⁄₅, niet ½. Onthoud: kijk altijd naar het totaal aantal stukken."
        }
      }
    },
    {
      "id": "GET-BREUK-GETALLENLIJN-003",
      "familyId": "GET-BREUK-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Een cartograaf tekent een getallenlijn van 0 tot 2. Waar op de lijn ligt de breuk ⁵⁄₄?",
      "options": [
        "tussen 1 en 2",
        "tussen 0 en 1",
        "precies op 1",
        "precies op 2"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 0,
            "end": 2,
            "step": 0.25,
            "label": "Getallenlijn van 0 tot 2 — waar plaats jij ⁵⁄₄?"
          },
          "a11y": { "alt": "Getallenlijn van 0 tot 2 met kwart-stappen, geen markering" }
        }
      ],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 0,
            "end": 2,
            "step": 0.25,
            "marked": [1.25],
            "label": "⁵⁄₄ = 1¼ — tussen 1 en 2",
            "fractionLabels": { "0": "0", "0.5": "½", "1": "1", "1.25": "1¼", "1.5": "1½", "2": "2" }
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuken groter dan 1",
            "content": "Als de teller groter is dan de noemer, is de breuk groter dan 1. Reken uit: teller ÷ noemer. Voorbeeld: ⁵⁄₄ = 5 ÷ 4 = 1¼.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_getallenlijn_groter_dan_1",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Bepaal eerst of de breuk groter of kleiner is dan 1. Bij ⁵⁄₄ is de teller (5) groter dan de noemer (4), dus de breuk is groter dan 1. ⁵⁄₄ = 1¼ = 1,25. Dat ligt tussen 1 en 2 op de getallenlijn.",
        "solutionSteps": [
          "Vergelijk teller en noemer: 5 > 4 → breuk is groter dan 1",
          "Reken uit: ⁵⁄₄ = 1¼ = 1,25",
          "1,25 ligt tussen 1 en 2"
        ],
        "distractorExplanations": {
          "0": "Goed! ⁵⁄₄ = 1¼ = 1,25. Dat ligt tussen 1 en 2 op de getallenlijn.",
          "1": "Je dacht waarschijnlijk dat alle breuken kleiner zijn dan 1. Maar ⁵⁄₄ heeft een teller (5) die groter is dan de noemer (4), dus de breuk is groter dan 1. Onthoud: teller > noemer = breuk > 1.",
          "2": "Je dacht waarschijnlijk dat ⁵⁄₄ gelijk is aan 1. Maar ⁴⁄₄ = 1, en ⁵⁄₄ = 1 + ¼ = 1,25. Onthoud: pas als teller = noemer is de breuk precies 1.",
          "3": "Je dacht waarschijnlijk dat ⁵⁄₄ gelijk is aan 2. Maar ⁸⁄₄ = 2, en ⁵⁄₄ = 1,25. Onthoud: reken de breuk uit door teller ÷ noemer."
        }
      }
    },
    {
      "id": "GET-BREUK-GETALLENLIJN-004",
      "familyId": "GET-BREUK-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Een getallenlijn van 0 tot 1 is verdeeld in 8 gelijke stukken. Welke breuk ligt precies op de helft?",
      "options": [
        "⁴⁄₈",
        "⁵⁄₈",
        "³⁄₈",
        "⁸⁄₈"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 0,
            "end": 1,
            "step": 0.125,
            "label": "Getallenlijn van 0 tot 1, verdeeld in 8 gelijke stukken — welke breuk ligt halverwege?"
          },
          "a11y": { "alt": "Getallenlijn 0-1 met 8 gelijke stukken, geen markering" }
        }
      ],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 0,
            "end": 1,
            "step": 0.125,
            "marked": [0.5],
            "highlight": [0.5],
            "label": "De helft (½) = ⁴⁄₈ — het 4e streepje van 8",
            "fractionLabels": { "0": "0", "0.5": "⁴⁄₈ = ½", "1": "1" }
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De helft als breuk",
            "content": "De helft = ½. Zoek de gelijkwaardige breuk met de juiste noemer. Voorbeeld: ½ = ⁴⁄₈ (want 8 ÷ 2 = 4).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_getallenlijn_helft",
      "variantIndex": 4,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "De helft van de lijn = ½. Zoek de gelijkwaardige breuk met noemer 8. ½ = ?⁄₈. Reken uit: 8 ÷ 2 = 4, dus ½ = ⁴⁄₈. Het vierde streepje op een lijn verdeeld in 8 stukken is precies de helft.",
        "solutionSteps": [
          "De helft = ½",
          "Zoek gelijkwaardige breuk: ½ = ?⁄₈",
          "8 ÷ 2 = 4, dus ½ = ⁴⁄₈",
          "Het vierde streepje is precies halverwege"
        ],
        "distractorExplanations": {
          "0": "Goed! De helft = ½ = ⁴⁄₈. Op een lijn van 8 stukken is het vierde streepje precies halverwege.",
          "1": "Je dacht waarschijnlijk dat 5 stukken de helft is. Maar ⁵⁄₈ ligt voorbij de helft — 5 van de 8 stukken is meer dan de helft (4 van de 8). Onthoud: de helft van 8 = 4.",
          "2": "Je dacht waarschijnlijk dat 3 stukken de helft is. Maar ³⁄₈ ligt vóór de helft — 3 van de 8 stukken is minder dan de helft (4 van de 8). Onthoud: de helft van 8 = 4.",
          "3": "Je dacht waarschijnlijk dat ⁸⁄₈ de helft is. Maar ⁸⁄₈ = 1, dat is het einde van de lijn. Onthoud: de helft is ⁴⁄₈, niet ⁸⁄₈."
        }
      }
    },
    {
      "id": "GET-BREUK-GETALLENLIJN-005",
      "familyId": "GET-BREUK-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Op een getallenlijn van 0 tot 1, verdeeld in 6 stukken, welke twee breuken zijn gelijk?",
      "options": [
        "²⁄₆ en ⅓",
        "²⁄₆ en ½",
        "³⁄₆ en ⅓",
        "⅙ en ⅓"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 0,
            "end": 1,
            "step": 0.167,
            "label": "Getallenlijn van 0 tot 1 in 6 stukken — welke breuken vallen samen?"
          },
          "a11y": { "alt": "Getallenlijn 0-1 met 6 gelijke stukken, geen markeringen" }
        }
      ],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 0,
            "end": 1,
            "step": 0.167,
            "marked": [0.333],
            "label": "²⁄₆ = ⅓ (beide op het 2e streepje van 6, ofwel 1e streepje van 3)",
            "fractionLabels": { "0": "0", "0.333": "²⁄₆ = ⅓", "1": "1" }
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gelijkwaardige breuken",
            "content": "Vereenvoudig een breuk door teller en noemer door hetzelfde getal te delen. Als twee breuken dezelfde waarde hebben, liggen ze op hetzelfde punt op de getallenlijn.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_getallenlijn_gelijkwaardig",
      "variantIndex": 5,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Vereenvoudig de breuken en kijk welke op hetzelfde punt liggen. ²⁄₆ vereenvoudigen: 2 en 6 delen door 2 → ⅓. Dus ²⁄₆ = ⅓ — ze liggen op hetzelfde punt op de getallenlijn. Controleer: ²⁄₆ = 2 van de 6 stukken = ⅓ van de lijn ✓.",
        "solutionSteps": [
          "Vereenvoudig ²⁄₆: deel teller en noemer door 2",
          "²⁄₆ = ⅓",
          "Controleer: ²⁄₆ = 2 van de 6 stukken = ⅓ van de lijn ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! ²⁄₆ = ⅓ (beide delen door 2). Ze liggen op hetzelfde punt op de getallenlijn.",
          "1": "Je dacht waarschijnlijk dat ²⁄₆ gelijk is aan ½. Maar ²⁄₆ = ⅓ ≈ 0,33 en ½ = ³⁄₆ = 0,5. Onthoud: vereenvoudig eerst de breuk om te controleren.",
          "2": "Je dacht waarschijnlijk dat ³⁄₆ gelijk is aan ⅓. Maar ³⁄₆ = ½ (delen door 3), niet ⅓. Onthoud: ⅓ = ²⁄₆, en ½ = ³⁄₆.",
          "3": "Je dacht waarschijnlijk dat ⅙ gelijk is aan ⅓. Maar ⅙ is de helft van ⅓. Op de getallenlijn ligt ⅙ op het eerste streepje en ⅓ (= ²⁄₆) op het tweede. Onthoud: ⅙ ≠ ⅓."
        }
      }
    },
    {
      "id": "GET-BREUK-GETALLENLIJN-CJ-001",
      "familyId": "GET-BREUK-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_getallenlijn",
      "questionType": "comparison_judge",
      "question": "Welke breuk staat het verst rechts op de getallenlijn (0–1)?",
      "context": null,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "a", "content": "½", "label": "een half" },
            { "id": "b", "content": "¾", "label": "drie kwart" },
            { "id": "c", "content": "⅔", "label": "twee derde" }
          ],
          "criterion": "het verst rechts (grootst)",
          "correctIndex": 1
        }
      },
      "options": [],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 0,
            "end": 1,
            "step": 0.25,
            "label": "Getallenlijn van 0 tot 1"
          },
          "a11y": { "alt": "Getallenlijn van 0 tot 1 om de breuken op te plaatsen" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuken vergelijken via gelijke noemer",
            "content": "Maak de noemers gelijk: ½ = ⁶⁄₁₂, ¾ = ⁹⁄₁₂, ⅔ = ⁸⁄₁₂. Hoe groter de teller bij gelijke noemer, hoe groter de breuk. Dus ¾ is het grootst en staat het verst rechts.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_vergelijken_getallenlijn",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Zet de breuken op dezelfde noemer (12): ½ = ⁶⁄₁₂, ¾ = ⁹⁄₁₂, ⅔ = ⁸⁄₁₂. Vergelijk de tellers: 6 < 8 < 9. Dus ¾ is het grootst en staat het verst rechts op de getallenlijn.",
        "solutionSteps": [
          "Maak de noemers gelijk (kleinste gemene veelvoud van 2, 4, 3 = 12)",
          "½ = ⁶⁄₁₂, ¾ = ⁹⁄₁₂, ⅔ = ⁸⁄₁₂",
          "Vergelijk tellers: 9 > 8 > 6",
          "¾ is het grootst → staat het verst rechts"
        ]
      },
      "pedagogy": { "dok": 2 }
    }
  ]
}